import _ from "lodash"

export default {
    loading: state => state.loading,
    menuItems: state => _.cloneDeep(state.menuItems),
    product: state => _.cloneDeep(state.product),
    isActiveNutritional: state => state.isActiveNutritional, 
    menuItemKey: state => state.menuItemKey,
    breadcrumb: state => state.breadcrumb,    
}